<template>
  <div>
    <p>{{ isInitialized }}</p>
    <p @click="emailLogin('rlaqjadud195@gmail.com', '123456kkAA!')">
      login click me
    </p>
    <p @click="writeDb()">writeDb</p>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      isInitialized: false,
      title: "테스트 제목",
      contents: "테스트 콘텐츠",
      category: 1,
      link: "https://naver.com",
      location: "인천",
      order: 1, // get category.length +1  maybe
      thumbnail: "https://naver.comanvave",
      posts1: [],
    };
  },
  mounted() {
    this.checkIsInitialized();

    firebase
      .firestore()
      .collection("posts1")
      .get()
      .then((snap) => {
        const testCollection = [];
        snap.forEach((doc) => {
          testCollection.push({ [doc.id]: doc.data() });
        });
        this.posts1 = testCollection;
      });
  },
  methods: {
    checkIsInitialized: function () {
      if (firebase.apps.length === 0) {
        console.log(firebase.app.length + " not initialized");
        this.isInitialized = false;
      } else {
        console.log(firebase.app.length + " initialized");
        this.isInitialized = true;
        firebase.auth().onAuthStateChanged((user) => {
          console.log(user);
        });
      }
    },
    emailLogin(email, password) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((user) => {
          console.log("successful");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    writeDb() {
      firebase
        .firestore()
        .collection("posts1")
        .doc()
        .set({
          category: this.category,
          title: this.title,
          contents: this.contents,
          link: this.link,
          order: this.order,
          thumbnail: this.thumbnail,
          location: this.location,
          isHotPick: false,
        })
        .then((data) => {
          alert("과거의 개진아,,, 수고했다");
        });
    },
  },
};
</script>

<style></style>
